export default __webpack_public_path__ + "static/media/pflegerat_white.3426c2b5.jpg";